/** `itemListName` on products from a recommendation screen, so they can be told apart from browse clicks. */
export const RECOMMENDATIONS_LIST_NAME = 'Recommendations';
/** The confirmation and recommendations pages fall back to featured listings when nothing was recommended. */
export const FEATURED_FALLBACK_LIST_NAME = 'Featured listings';

/** The fields a recommendation card needs to describe its listing in an analytics product. */
export interface RecommendationListingLike {
  readonly id: string;
  readonly experienceId?: string | null;
  readonly title?: string | null;
  readonly category?: { readonly name: string } | null;
  readonly startingPrice?: number | null;
}

export interface RecommendationAnalyticsProduct {
  readonly itemListName: string;
  readonly id: string;
  readonly title: string | null;
  readonly category: string | null;
  readonly index: number;
  readonly startingPrice: number | null;
}

// Same shape the catalog and calendar pages send, so GA4's item mapping and the funnel table's
// products column read it without changes. Resource listings have no experience id; use the listing's.
export const recommendationAnalyticsProduct = (
  listing: RecommendationListingLike,
  index: number,
  itemListName: string = RECOMMENDATIONS_LIST_NAME,
): RecommendationAnalyticsProduct => ({
  itemListName,
  id: listing.experienceId ?? listing.id,
  title: listing.title ?? null,
  category: listing.category?.name ?? null,
  index,
  startingPrice: listing.startingPrice ?? null,
});
